import React from 'react';
import { Checkbox } from 'components/ui/checkbox';

interface TermsCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const TermsCheckbox: React.FC<TermsCheckboxProps> = ({ checked, onChange }) => {
  return (
    <div className="mt-4">
      <label className="flex items-center gap-3 text-xs text-muted-foreground hover:cursor-pointer">
        <Checkbox
          id="terms"
          checked={checked}
          onCheckedChange={(value) => onChange(value === true)}
          className="mt-1"
        />
        <span className="leading-relaxed text-foreground">
          I agree to the{' '}
          <a href="/terms" target="_blank" rel="noreferrer" className="text-primary hover:text-primary/80">
            Terms and Conditions
          </a>
        </span>
      </label>
    </div>
  );
};
